import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { colors } from "./theme";

// Shared building blocks for the in-app "wiki" guides (AgentHomeView's AgentGuide,
// the console's AdminGuide). Collapsible sections + a tidy two-column mini-table.

export function GuideSection({
  title,
  defaultExpanded = false,
  children,
}: {
  title: string;
  defaultExpanded?: boolean;
  children: React.ReactNode;
}) {
  return (
    <Accordion
      defaultExpanded={defaultExpanded}
      disableGutters
      elevation={0}
      sx={{ border: `1px solid ${colors.gray200}`, "&:not(:last-of-type)": { borderBottom: 0 } }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography sx={{ fontWeight: 600 }}>{title}</Typography>
      </AccordionSummary>
      <AccordionDetails
        sx={{ color: colors.gray700, "& p": { mb: 1.5 }, "& ul": { mt: 0, mb: 1.5, pl: 3 }, "& li": { mb: 0.5 } }}
      >
        {children}
      </AccordionDetails>
    </Accordion>
  );
}

export function GuideTable({ rows }: { rows: [string, React.ReactNode][] }) {
  return (
    <Table size="small" sx={{ mt: 1, "& td": { borderColor: colors.gray200, verticalAlign: "top", fontSize: "0.85rem", py: 0.75 } }}>
      <TableBody>
        {rows.map(([k, v], i) => (
          <TableRow key={i}>
            <TableCell sx={{ fontWeight: 600, whiteSpace: "nowrap", width: 1 }}>{k}</TableCell>
            <TableCell>{v}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}

// Convenience wrapper: the rounded, clipped container the accordion stack sits in.
export function GuideStack({ children }: { children: React.ReactNode }) {
  return <Box sx={{ borderRadius: 1, overflow: "hidden" }}>{children}</Box>;
}
